import { render, staticRenderFns } from "./PetDob.vue?vue&type=template&id=7bb413b2&scoped=true"
import script from "./PetDob.vue?vue&type=script&lang=js"
export * from "./PetDob.vue?vue&type=script&lang=js"
import style0 from "./PetDob.vue?vue&type=style&index=0&id=7bb413b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb413b2",
  null
  
)

export default component.exports